@if (matrixQuestion.rows[0].type === "MULTIPLE_CHOICE") {
  @if (allRowsHaveRequiredError) {
    <app-validator
      [question]="matrixQuestion"
      [validator]="ValidatorType.RequiredSelect"
    />
  }
  @if (!isMobileView) {
    <div class="w-full max-w-full matrix-wrapper">
      <!-- Sticky header (clone) -->
      <div class="matrix-sticky-header" #stickyHeader aria-hidden="true">
        <div class="matrix-sticky-corner"></div>
        <div class="matrix-sticky-clip">
          <div class="matrix-sticky-inner" #stickyInner>
            <table class="table sticky-header-table">
              <thead>
                <tr class="align-top">
                  <th
                    class="left-0 z-[1] min-w-64"
                    scope="col"
                    aria-hidden="true"
                  ></th>
                  @for (
                    alternative of matrixQuestion.rows[0].alternatives;
                    track $index
                  ) {
                    <th
                      class="px-1 text-wrap"
                      scope="col"
                      [style.width]="
                        getColumnWidth(
                          matrixQuestion.rows[0].alternatives.length,
                          matrixQuestion.rows[0].alternatives,
                          matrixQuestion.rows[0].id
                        )
                      "
                      [style.min-width]="
                        getColumnMinWidth(
                          alternative.title,
                          matrixQuestion.rows[0].id
                        )
                      "
                    >
                      <div class="inline-block">
                        @if (alternative.image) {
                          <img
                            [src]="alternative.image.url"
                            [alt]="
                              alternative.image.alternateText || alternative.title
                            "
                            [style.width.px]="alternative.image.width"
                            [style.height.px]="alternative.image.height"
                            [style.object-fit]="'fill'"
                            [style.display]="'block'"
                          />
                        }
                        @if (!alternative.image?.hideTitle) {
                          <span [innerHTML]="alternative.title | safeHtml"></span>
                        }
                      </div>
                    </th>
                  }
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>

      <!-- Main table container -->
      <div class="table-container" #tableContainer (scroll)="onTableScroll()">
        <table
          class="table mt-8 mb-4"
          [style.--header-first-row-height]="headerFirstRowHeight + 'px'"
        >
          <thead>
            <tr class="align-top">
              <th
                class="left-0 z-[1] min-w-64"
                scope="col"
                [id]="'corner-' + matrixQuestion.id"
                aria-hidden="true"
              ></th>
              @for (
                alternative of matrixQuestion.rows[0].alternatives;
                track $index
              ) {
                <th
                  class="px-1 text-wrap"
                  scope="col"
                  [style.width]="
                    getColumnWidth(
                      matrixQuestion.rows[0].alternatives.length,
                      matrixQuestion.rows[0].alternatives,
                      matrixQuestion.rows[0].id
                    )
                  "
                  [style.min-width]="
                    getColumnMinWidth(alternative.title, matrixQuestion.rows[0].id)
                  "
                  [id]="(alternative.title | toValidId) + '-' + matrixQuestion.id"
                >
                  <div class="inline-block">
                    @if (alternative.image) {
                      <img
                        [src]="alternative.image.url"
                        [alt]="alternative.image.alternateText || alternative.title"
                        [style.width.px]="alternative.image.width"
                        [style.height.px]="alternative.image.height"
                        [style.object-fit]="'fill'"
                        [style.display]="'block'"
                      />
                    }
                    @if (!alternative.image?.hideTitle) {
                      <span [innerHTML]="alternative.title | safeHtml"></span>
                    }
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (question of matrixQuestion.rows; track $index) {
              @if (question.type === "MULTIPLE_CHOICE") {
                <tr class="table-row">
                  <th
                    class="sticky text-left align-middle left-0 min-w-64 px-3"
                    scope="row"
                    [id]="(question.title | toValidId) + '-' + matrixQuestion.id"
                  >
                    <span [innerHTML]="question.title | safeHtml"></span>
                    @if (
                      getFormGroup(question.id, form).hasError(
                        "atLeastOneRequired"
                      ) &&
                      getFormGroup(question.id, form).touched &&
                      !allRowsHaveRequiredError
                    ) {
                      <app-validator
                        class="font-normal"
                        [question]="question"
                        [validator]="ValidatorType.RequiredSelect"
                      />
                    }
                  </th>

                  <app-multi-select
                    class="contents"
                    [question]="question"
                    [formGroup]="getFormGroup(question.id, form)"
                    [otherControl]="form.get(question.id + '-OTHER')"
                    [inTable]="true"
                    [rowTitle]="
                      (question.title | toValidId) + '-' + matrixQuestion.id
                    "
                    [columnIdSuffix]="matrixQuestion.id"
                    [parentTableSelector]="'app-matrix-multi-select'"
                  ></app-multi-select>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <!-- Custom scrollbar -->
      @if (hasHorizontalOverflow) {
        <div
          class="custom-scrollbar-track"
          #scrollbarTrack
          [style.margin-left.px]="firstColumnWidth"
          (mousedown)="onScrollbarTrackClick($event)"
        >
          <div
            class="custom-scrollbar-thumb"
            [style.width.px]="scrollbarThumbWidth"
            [style.transform]="'translateX(' + scrollbarThumbPosition + 'px)'"
            (mousedown)="onScrollbarThumbMouseDown($event)"
          ></div>
        </div>
      }
    </div>
  }

  @if (isMobileView) {
    <div class="block">
      @for (question of matrixQuestion.rows; track $index) {
        @if (question.type === "MULTIPLE_CHOICE") {
          <div class="mb-4">
            <h3
              class="font-semibold mt-3"
              [innerHTML]="question.title | safeHtml"
            ></h3>
            <app-multi-select
              class="contents"
              [question]="question"
              [formGroup]="getFormGroup(question.id, form)"
              [otherControl]="form.get(question.id + '-OTHER')"
              [inMobileAndMatrix]="true"
            ></app-multi-select>
          </div>
        }
      }
    </div>
  }
}
